import React, { Component } from 'react'
import { graphql } from '@apollo/client/react/hoc' // Updated Apollo HOC import
import { Badge, Button, UncontrolledTooltip, Alert, Progress, FormGroup, Nav, NavItem, NavLink, Input, Form, TabContent, TabPane } from 'reactstrap'
import OverviewTab from './OverviewTab'
import { DeleteDriverMutation, UpdateDriver, ReActivateDriverOnApp, } from "../Mutations"
import { ReactComponent as NotMobileUserIcon } from '../../../../assets/images/icons/notMobileUser.svg'
import { ReactComponent as MobileUserIcon } from '../../../../assets/images/icons/mobileUser.svg'
import ConfirmationPopup from "../../../../Material/ConfirmationPopup"
import DocumentsTab from "./DocumentTab/DocumentTab"
import HistoryTab from "./HistoryTab/HistoryTab"
import LeadsTab from "./LeadsTab/LeadsTab"
import BillingTab from "./BillingTab/BillingTab"
import DriverReservationTab from "./ReservationTab/DriverReservationTab"
import RentalTab from '../../../../Material/RentalTab/RentalTab'
import RelatedProfileTab from "./RelatedProfilesTab/RelatedProfilesTab"
import gql from 'graphql-tag'
import InteractionContainer from "../../../Interactions/InteractionsContainer"
import renderEnumToInt from "../../../../Functions/renderEnumToInt"
import ReservationModalNew from "../../../../Reservations/Modals/ReservationModalNew"
import './DriverDetailNew.css'
import CopyToClipboard from "../../../../Material/CopyToClipboard"
import { HasPermissionsQuery } from "../../../../Functions/querys"
import { ReactComponent as FrontIcon } from '../../../../assets/images/icons/frontapp-icon.svg'
import { ReactComponent as InOffice } from '../../../../assets/images/icons/in-office.svg'
import { ReactComponent as NoCard } from '../../../../assets/images/icons/no-card.svg'
import { StripeCards } from "../Queries"
import RiskTab from "./RiskTab/RiskTab"
import AddToDNR from "../../../DNR/AddToDNR"
import withApolloClient from "../../../../withApolloClient"
import { EMAIL_REGEX } from "../../../../Constants"
import IncidentsTab from "./IncidentsTab/IncidentsTab"
import GenerateMVR from '../GenerateMVR'
import ExternalIntegrations from './Components/ExternalIntegrations'
import DriverUpdateTagsPopover from '../../Tags/DriverUpdateTagsPopover'

const DriverQuery = gql`query Driver($id: ID!){
    driver(id: $id){
        id
        pk
        name
        phone
        email
        canDelete
        dmvLicense
        dob
        state
        frontLastMsg
        inOffice
        isBlocked
        hasIncompleteReturn
        isRelatedProfileBlocked
        tags { id name color }
        geoLocation {
            latitude
            longitude
            timestamp
        }
        activeInsurance{
            id
        }
        currentAgreement{
            id
            agreementType
            car{
                id
                pk
                trackerLocation {
                    longitude
                    latitude
                }
            }
        }
        missingRentalDocuments{
            id
            typeName
        }
        mobileappdriver {
            id
            active
          }
        branch{
            id
            name
            requiresInsurance
        }
    }
}
`

export const RetentionScoreQuery = gql`
  query RetentionScore($driverId: ID!) {
    retentionScoreColor(driverId: $driverId)
  }
`

const RETENTION_SCORE_MAPPING = {
    "GOLD": "#ffa74fff",
    "SILVER": "#C0C0C0",
    "BRONZE": "#955D25"
}

let DRIVER_DETAIL_PAGE_TABS = [
    { id: "#overview", name: "OVERVIEW", querParams: false, },
    { id: "#billing", name: "BILLING", queryParams: true, },
    { id: "#rentals", name: "RENTALS", queryParams: true, },
    { id: "#reservations", name: "RESERVATIONS", queryParams: true, },
    { id: "#risk", name: "RISK", queryParams: false, },
    { id: "#incidents", name: "INCIDENTS", queryParams: false, },
    { id: "#documents", name: "DOCUMENTS", queryParams: true, },
    { id: "#interactions", name: "INTERACTIONS", queryParams: false, },
    { id: "#history", name: "HISTORY", queryParams: false, },
    { id: "#leads", name: "LEADS", queryParams: false, },
    { id: "#relatedProfiles", name: "RELATED PROFILES", queryParams: false, },
]
class DriverDetailContainer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            tab: "",
            loading: false,
            error: "",
            input: {},
            openModal: "",
            rendererdTabPanes: [],
            emailVerified: false,
            behaviorReportLoading: false,
            behaviorReportError: "",
            behaviorReportSuccess: "",
        }
    }
    updateInput = (e) => {
        let value = e.target.value
        let name = e.target.name
        if (name === "email") {
            if (EMAIL_REGEX.test(value))
                this.setState({ emailVerified: true, error: "" })
            else
                this.setState({ emailVerified: false, error: "Please enter a valid email address." })
        }
        this.setState({ value: value })
    };
    toggleModal = (modalName) => {
        if (this.state.openModal === modalName) {
            this.setState({ openModal: "" })
        } else {
            this.setState({ openModal: modalName })
        }
    }

    updateDriver = (driverId, name, value) => {
        let defValue = this.state[name]
        try {
            if (driverId && name && value && value !== defValue) {
                this.setState({ loading: true })
                let input = {
                    id: driverId,
                    [name]: this.props.name === "stage" ? renderEnumToInt(value) : value
                }

                this.props.apolloClient.mutate({
                    mutation: UpdateDriver,
                    variables: { input },
                }).then((result) => {
                    if (result && result.data && result.data.updateDriver && result.data.updateDriver.ok) {
                        this.setState({ editField: "", loading: false, error: "" })
                        this.props.refetchDriverQuery()

                    } else if (result && result.data && result.data.updateDriver && result.data.updateDriver.errors && result.data.updateDriver.errors[0] && result.data.updateDriver.errors[0].messages) {
                        this.setState({ loading: false, error: result.data.updateDriver.errors[0].messages.toString() })
                    } else {
                        this.setState({ loading: false, error: "Something went wrong, Please contact admin for support!" })
                    }
                }).catch((err) => {
                    this.setState({ loading: false, error: err.message })
                })
            } else if (value === this.state.value) {
                this.setState({ editField: "", loading: false, error: "" })
            }
        } catch (err) {
            this.setState({ loading: false, error: err })
        }
    }

    deleteDriverProfile = (e) => {
        try {
            if (this.props.driver && this.props.driver.id) {
                this.setState({ loading: true })
                let input = {
                    id: this.props.driver ? this.props.driver.id : null,
                }
                this.props.apolloClient.mutate({
                    mutation: DeleteDriverMutation,
                    variables: { input },
                }).then((result) => {
                    if (result && result.data && result.data.deleteDriver && result.data.deleteDriver.ok) {
                        this.setState({ error: "", openModal: "" })
                        window.open("/", "_self")
                    } else {
                        let error = "An error occurred, could not complete request."
                        if (result.data && result.data.deleteDriver && result.data.deleteDriver.errors && result.data.deleteDriver.errors[0] && result.data.deleteDriver.errors[0].messages) {
                            error = result.data.deleteDriver.errors[0].messages.toString()
                        }
                        this.setState({ error: error })
                    }
                    this.setState({ loading: false })
                }).catch((err) => {
                    let error = "An error has occured: Please contact admin: " + err
                    this.setState({ error: error })
                    this.setState({ loading: false })
                })
            }
            else this.setState({ error: "Same Branch Selected" })
        }
        catch (err) {
            let error = "An error has occured: " + err
            this.setState({ error: error })
            this.setState({ loading: false })
        }
    }
    updateDriverAppStatus = () => {
        this.setState({ loading: true })
        let input = {
            'driverId': this.props.driver.id,
            'active': true
        }
        this.props.apolloClient.mutate({
            mutation: ReActivateDriverOnApp,
            variables: { input },
        }).then((result) => {
            if (result && result.data && result.data.setDriverActiveStatus && result.data.setDriverActiveStatus.ok) {
                this.props.refetchDriverQuery()
                this.setState({ loading: false, error: null })
            } else {
                this.setState({ loading: false, error: "An error has occurred. Please check your input or contact admin." })
            }
        }).catch((err) => {
            this.setState({ loading: false, error: "An error has occurred. Please contact admin: " + err })
        })
    }
    editField(type, id) {
        if (id) {
            this.setState({ [type]: id, value: id })
        }
        if (type === this.state.editField) {
            this.setState({ error: null })
        }
        this.setState({ editField: type === this.state.editField ? "" : type })
    }

    toggleTab = (tabId) => {
        if (!this.state.rendererdTabPanes.includes(tabId)) {
            this.setState({ rendererdTabPanes: [...this.state.rendererdTabPanes, tabId] })
        }
        this.props.navigate({ hash: this.state.tab })
        this.setState({ tab: tabId })
    }

    componentDidMount() {
        const { apolloClient } = this.props
        let defaultTab = DRIVER_DETAIL_PAGE_TABS[0].id
        if (window.location.hash && DRIVER_DETAIL_PAGE_TABS.map(item => item.id).includes(window.location.hash)) {
            this.setState({ tab: window.location.hash, rendererdTabPanes: [window.location.hash] })
        } else {
            window.location.hash = defaultTab
            this.setState({ tab: defaultTab, rendererdTabPanes: [defaultTab] })
        }

    }
    componentDidUpdate(_, prevState) {
        if (this.state.tab !== prevState.tab) {
            this.props.navigate({
                hash: this.state.tab,
                search: DRIVER_DETAIL_PAGE_TABS.filter(obj => obj.queryParams)
                    .map(obj => obj.id)
                    .includes(this.state.tab) &&
                    this.state.rendererdTabPanes &&
                    this.state.rendererdTabPanes.includes(this.state.tab)
                    ? window.location.search
                    : "",
            })
        }
    }
    render() {
        if (!this.props.driver && this.props.loading) {
            return <Progress animated color="info" value="100" />
        }
        if (!this.props.driver && !this.props.loading) {
            // Crash page not ui friendly so showing blank for now
            return ""
        }
        const retentionScoreColor = this.props.retentionScoreColor && RETENTION_SCORE_MAPPING[this.props.retentionScoreColor?.toUpperCase()] ? RETENTION_SCORE_MAPPING[this.props.retentionScoreColor?.toUpperCase()] : "none";
        const isMinave = this.props.driver?.branch?.name?.includes('Mi Nave');
        const permissions = this.props?.hasPermissions?.length > 0 ? this.props?.hasPermissions : [];
        const canDeleteDriver = permissions.includes("custom_can_delete_driver");
        const canAddBlockedCustomer = permissions.includes("add_blockedcustomer");
        const canRunMvr = permissions.includes("custom_can_run_mvr");
        return (
            <div className="driver-detail-container">
                {this.state.error && <Alert color="danger">{this.state.error}</Alert>}
                {this.state.openModal === "GenerateMVR"
                    && <GenerateMVR
                        driver={this.props.driver}
                        handleClose={() => this.toggleModal("")}
                        open={this.state.openModal === "GenerateMVR"}
                    />}

                <div className="driver-header">
                    <span className="driver-id-wrapper">
                        {this.props.driver ? "#" + this.props.driver.pk : "--"}&nbsp;&nbsp;
                        <CopyToClipboard textToCopy={this.props.driver ? this.props.driver.pk : "--"} displayText={"driver id"} />
                    </span>
                    <div className="driver-image" style={{ border: `5px solid ${retentionScoreColor}`, color: retentionScoreColor }}>
                        {this.props.driver && (this.props.driver.isBlocked || this.props.driver.isRelatedProfileBlocked) ?
                            <>
                                <i id={"isBlocked"} className="fa fa-3x fa-ban" aria-hidden="true"
                                    style={{ color: this.props.driver.isBlocked ? "red" : "orange" }}>
                                </i>
                                <UncontrolledTooltip target={"isBlocked"}>
                                    {this.props.driver.isBlocked ? "Blocked" : "Related Profile Blocked"}
                                </UncontrolledTooltip>
                            </> :
                            <i style={{ fontSize: "3em" }} className="fa fa-2x fa-user" aria-hidden="true"></i>
                        }
                    </div>
                    <div className="driver-name">
                        <label>
                            {this.props.driver && this.props.driver.name ? this.props.driver.name : ""}
                            <br />
                            <Badge color="primary" className="bos-badge-blue text-light">{this.props.driver && this.props.driver.branch ? this.props.driver.branch.name : "--"}</Badge>
                            &nbsp;&nbsp;
                            {this.props.driver && this.props.driver.mobileappdriver && this.props.driver.mobileappdriver.id ?
                                <MobileUserIcon width='15' /> : <NotMobileUserIcon width='15' />
                            }
                            {this.props.driver && this.props.driver.frontLastMsg &&
                                <>
                                    &nbsp;
                                    <UncontrolledTooltip target="front-conversation">Front Conversation</UncontrolledTooltip>
                                    <a id="front-conversation" target="_blank" href={this.props.driver.frontLastMsg.replace("api.", "").replace("messages", "open").replace("?referer=conversation", "")}><FrontIcon width='20' height="20" /></a>
                                </>
                            }
                            {this.props.driver && this.props.driver.inOffice &&
                                <>
                                    &nbsp;
                                    <InOffice id={"inOffice"} width={25} height={25} fill="#198754" />
                                    <UncontrolledTooltip target={"inOffice"}>Driver in Office</UncontrolledTooltip>
                                </>
                            }
                            {this.props.cards && this.props.cards.cards && this.props.cards.cards.length === 0 &&
                                <>
                                    &nbsp;
                                    <NoCard id={"noCard"} width={25} height={25} />
                                    <UncontrolledTooltip target={"noCard"}>No Card</UncontrolledTooltip>
                                </>
                            }
                            {this.props.driver?.hasIncompleteReturn &&
                                <>
                                    &nbsp;
                                    <Badge id="ir-alert" color="danger">Incomplete Return</Badge>
                                    <UncontrolledTooltip target="ir-alert">Driver has an incomplete return</UncontrolledTooltip>
                                </>
                            }
                        </label>
                    </div>
                    <div className="mr-auto">
                        <Form className="form-inline">
                            <FormGroup className="no-margin">
                                <Input className="driver-header-input" disabled={this.state.editField !== "phone"} value={this.props.driver && this.props.driver.phone ? this.props.driver.phone : "--"} onChange={this.updateInput} id="phone" />
                                <span style={{ display: "inline-flex", alignItems: "center" }}>
                                    {this.state.editField !== "phone" ?
                                        <span style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            &nbsp;
                                            <div className="driver-header-icon" style={{ borderRadius: "5px" }}>
                                                <CopyToClipboard textToCopy={this.props.driver && this.props.driver.phone ? this.props.driver.phone : ""} displayText={"phone number"} />
                                            </div>
                                        </span>
                                        :
                                        <div>
                                            &nbsp;&nbsp;
                                            <i className="fa fa-solid fa-lg fa-times" onClick={() => this.editField("phone")}></i>&nbsp;&nbsp;
                                            <i className="fa fa-solid fa-lg fa-check" onClick={() => this.updateDriver(this.props.driver.id, "phone", this.state.value)}></i>
                                        </div>
                                    }
                                </span>
                            </FormGroup>
                            &nbsp;&nbsp;
                            <FormGroup className="no-margin">
                                <Input className="driver-header-input" disabled={this.state.editField !== "email"} value={this.props.driver && this.props.driver.email ? this.props.driver.email : "--"} onChange={this.updateInput} id="email" name="email" />
                                <span style={{ display: "inline-flex", alignItems: "center" }}>
                                    {this.state.editField !== "email" ?
                                        <span style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                            &nbsp;
                                            <div className="driver-header-icon" style={{ borderRadius: "5px" }}>
                                                <CopyToClipboard textToCopy={this.props.driver && this.props.driver.email ? this.props.driver.email : ""} displayText={"email"} />
                                            </div>
                                        </span>
                                        :
                                        <div>
                                            &nbsp;&nbsp;
                                            <i className="fa fa-solid fa-lg fa-times" onClick={() => this.editField("email")}></i>&nbsp;&nbsp;
                                            {this.state.error === "" && <i className="fa fa-solid fa-lg fa-check" onClick={() => this.updateDriver(this.props.driver.id, "email", this.state.value)}></i>}
                                        </div>
                                    }
                                </span>
                            </FormGroup>
                        </Form>
                    </div>
                    <div>
                        <Button
                            onClick={() => this.toggleModal("NewReservationModal")}
                            disabled={(this.props.driver && this.props.driver.missingRentalDocuments && this.props.driver.missingRentalDocuments.length > 0) || (!this.props.driver.branch.requiresInsurance ? this.props.driver.branch.requiresInsurance : !(this.props.driver.activeInsurance && this.props.driver.activeInsurance.length > 0))}
                            className={"ghost mb-0"}
                        >
                            {!this.props.driver.branch.requiresInsurance || (this.props.driver.activeInsurance && this.props.driver.activeInsurance.length > 0) ? ((this.props.driver && this.props.driver.missingRentalDocuments && this.props.driver.missingRentalDocuments.length > 0) ?
                                "Missing Pickup Docs: " + this.props.driver.missingRentalDocuments.map(i => i.typeName).toString() : "RESERVE A CAR") : "No Active Insurance"}
                        </Button>&nbsp;&nbsp;
                        {this.state.openModal === "NewReservationModal" &&
                            <ReservationModalNew
                                handleClose={() => this.toggleModal("")}
                                open={this.state.openModal === "NewReservationModal"}
                                title={"Create New Reservation"}
                                driverId={this.props.driver.id}
                                refetchQuery={this.props.refetchDriverQuery}
                                isUpdate={false}
                                skip={true}
                                path={"driverDetail"}
                            />
                        }

                        {!isMinave &&
                            <>
                                <Button onClick={() => this.toggleModal("GenerateMVR")} id={"runDriverMVR"} className={"ghost mb-0"} disabled={!canRunMvr} title={!canRunMvr ? "You do not have permission to run MVR." : ""}>
                                    GENERATE MVR
                                </Button>&nbsp;
                            </>
                        }

                        {canAddBlockedCustomer && !this.props.driver.isBlocked &&
                            <><Button onClick={() => this.toggleModal("addToDNRModal")} className={"ghost mb-0"}>ADD TO DNR</Button>&nbsp;</>
                        }
                        {this.state.openModal === "addToDNRModal" &&
                            <AddToDNR
                                handleClose={() => this.toggleModal("")}
                                open={this.state.openModal === "addToDNRModal"}
                                driverId={this.props.driver.id}
                                refetchQuery={this.props.refetchDriverQuery}
                            />
                        }
                        {this.props.driver && this.props.driver.mobileappdriver && !(this.props.driver.mobileappdriver.active) && <Button onClick={() => this.updateDriverAppStatus()} className={"ghost mb-0"}>Reactivate Driver's App</Button>}

                        {this.props.driver && this.props.driver.canDelete && canDeleteDriver && <>
                            <Button onClick={() => this.toggleModal("deleteProfile")} id={"deleteProfile"} className={"mb-0"} color="danger"><i className="fa fa-trash" aria-hidden="true"></i></Button> &nbsp;
                            <UncontrolledTooltip placement="top" target={"deleteProfile"}>Delete Profile</UncontrolledTooltip>
                            {this.state.openModal === "deleteProfile" &&
                                <ConfirmationPopup
                                    open={this.state.openModal === "deleteProfile"}
                                    message={"DELETING THIS DRIVER WILL ALSO DELETE ALL THE RELATED DOCUMENTS, INSURANCES AND OTHER DATA. ARE YOU SURE YOU WANT TO DELETE THIS DRIVER?"}
                                    loading={this.state.loading}
                                    handleClose={() => this.toggleModal("")}
                                    action={"Yes"}
                                    confirmAction={this.deleteDriverProfile}
                                    color="danger"
                                    error={this.state.error ? this.state.error : ""}
                                />
                            }
                        </>
                        }
                    </div>
                </div>
                <div className="driver-tags">
                    TAGS: {this.props.driver.tags && this.props.driver.tags.length > 0 && (
                        this.props.driver.tags.map(tag => (
                            <Badge key={tag.id} size="lg" color={tag.color ? tag.color : "secondary"}>{tag.name}</Badge>
                        ))
                    )}
                    <Badge id="editTag" size="sm" color='success' style={{ backgroundColor: "success", paddingLeft: "10px", paddingRight: "10px", cursor: "pointer" }} onClick={() => this.toggleModal("editTag")}>
                        <span><i style={{ width: "100%", display: "inline-block" }} className="fa fa-lg fa-plus" aria-hidden="true" /></span>
                    </Badge>
                    <UncontrolledTooltip target="editTag" placement="top">Add Or Remove Driver Tag</UncontrolledTooltip>
                    {this.state.openModal === "editTag" &&
                        <DriverUpdateTagsPopover
                            isOpen={this.state.openModal === "editTag"}
                            handleClose={() => this.toggleModal("")}
                            refetchQuery={() => { return true }}
                            driverId={this.props.driver.id}
                            driverTags={this.props.driver.tags}
                            target="editTag"
                        />
                    }
                </div>
                {this.props.driver &&
                    <div className="row-flex">
                        <div className="driver-detail width-100">
                            <Nav tabs>
                                {DRIVER_DETAIL_PAGE_TABS.map(item =>
                                    <NavItem key={item.id} className={this.state.tab === item.id ? "active" : "inactive"}>
                                        <NavLink className={this.state.tab === item.id ? "active" : "inactive"} onClick={() => this.toggleTab(item.id)}>
                                            {item.name}
                                        </NavLink>
                                    </NavItem>
                                )}
                            </Nav>
                            <TabContent activeTab={this.state.tab}>
                                {this.state.rendererdTabPanes && this.state.rendererdTabPanes.includes("#overview") && <TabPane tabId="#overview">
                                    <OverviewTab currentUser={this.props.currentUser} id={this.props.driver.id} toggleTab={(id) => this.toggleTab(id)} refetchQuery={this.props.refetchDriverQuery} />
                                </TabPane>}
                                {this.state.rendererdTabPanes && this.state.rendererdTabPanes.includes("#rentals") && <TabPane tabId="#rentals">
                                    <RentalTab currentUser={this.props.currentUser} driverId={this.props.driver.id} {...this.props} activeTab={this.state.tab.slice(1)} viewType="driver" />
                                </TabPane>}
                                {this.state.rendererdTabPanes && this.state.rendererdTabPanes.includes("#reservations") && <TabPane tabId="#reservations">
                                    <DriverReservationTab currentUser={this.props.currentUser} id={this.props.driver.id} {...this.props} activeTab={this.state.tab.slice(1)} />
                                </TabPane>}
                                {this.state.rendererdTabPanes && this.state.rendererdTabPanes.includes("#documents") && <TabPane tabId="#documents">
                                    <DocumentsTab currentUser={this.props.currentUser} id={this.props.driver.id} activeTab={this.state.tab} {...this.props} />
                                </TabPane>}
                                {this.state.rendererdTabPanes && this.state.rendererdTabPanes.includes("#risk") && <TabPane tabId="#risk">
                                    <RiskTab currentUser={this.props.currentUser} driverId={this.props.driver.id} />
                                </TabPane>}
                                {this.state.rendererdTabPanes && this.state.rendererdTabPanes.includes("#incidents") && <TabPane tabId="#incidents">
                                    <IncidentsTab driverId={this.props.driver.id} {...this.props} currentUser={this.props.currentUser} activeTab={this.state.tab.slice(1)} />
                                </TabPane>}
                                {this.state.rendererdTabPanes && this.state.rendererdTabPanes.includes("#billing") && <TabPane tabId="#billing">
                                    <BillingTab currentUser={this.props.currentUser} id={this.props.driver.id} {...this.props} activeTab={this.state.tab.slice(1)} />
                                </TabPane>}
                                {this.state.rendererdTabPanes && this.state.rendererdTabPanes.includes("#interactions") && <TabPane tabId="#interactions">
                                    <InteractionContainer driverId={this.props.driver.id} interactionsType="driver" />
                                </TabPane>}
                                {this.state.rendererdTabPanes && this.state.rendererdTabPanes.includes("#history") && <TabPane tabId="#history">
                                    <HistoryTab currentUser={this.props.currentUser} id={this.props.driver.id} />
                                </TabPane>}
                                {this.state.rendererdTabPanes && this.state.rendererdTabPanes.includes("#leads") && <TabPane tabId="#leads">
                                    <LeadsTab currentUser={this.props.currentUser} id={this.props.driver.id} />
                                </TabPane>}
                                {this.state.rendererdTabPanes && this.state.rendererdTabPanes.includes("#relatedProfiles") && <TabPane tabId="#relatedProfiles">
                                    <RelatedProfileTab currentUser={this.props.currentUser} id={this.props.driver.id} dmvLicense={this.props.driver && this.props.driver.dmvLicense ? this.props.driver.dmvLicense : ""} />
                                </TabPane>}
                            </TabContent>
                        </div>
                        <ExternalIntegrations driverId={this.props.driver.id} />
                    </div>
                }
            </div >
        )
    }
}

export default graphql(DriverQuery, {
    options: (props) => ({
        variables: { id: props && props.params ? props.params.id : null },
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true,
    }),
    props({ data: { driver, loading, refetch, variables } }) {
        return {
            driver,
            loading,
            variables,
            refetchDriverQuery: () => {
                return refetch({
                    query: DriverQuery,
                    variables: {
                        ...variables,
                    },
                    updateQuery: (previousResult, { fetchMoreResult }) => {
                        return { driver: fetchMoreResult.driver }
                    },
                })
            },
        }
    },
})(
    graphql(HasPermissionsQuery, {
        options: () => ({
            variables: {
                userPermissions: ["custom_can_delete_driver", "add_blockedcustomer", "custom_can_run_mvr"],
            },
            fetchPolicy: 'network-only',
            notifyOnNetworkStatusChange: true,
        }),
        props({ data: { hasPermissions, loading, variables } }) {
            return {
                hasPermissions,
                loading,
                variables,
            }
        },
    })(
        graphql(StripeCards, {
            options: (props) => ({
                fetchPolicy: 'cache-and-network',
                variables: { id: props?.params?.id ?? null },
            }),
            props({ data: { loading: loadingStripCards, cards, variables } }) {
                return { loadingStripCards, cards, variables }
            },
        })(
            graphql(RetentionScoreQuery, {
                options: (props) => ({
                    variables: { driverId: props?.params?.id ?? null },
                    fetchPolicy: 'network-only',
                }),
                props({ data: { retentionScoreColor, loading: loadingRetention } }) {
                    return { retentionScoreColor, loadingRetention }
                },
            })(withApolloClient(DriverDetailContainer))
        )
    )
)
